const ClearCasterPersonality =
{
	FACEBOOK: 1,
	WORKPLACE: 2
}
export default ClearCasterPersonality;